import deferLoadScript from './defer-script-loader';
import loadScript from './script-loader';

let loader;
export default function loadYMaps(deferTimes) {
  if (!loader) {
    if (window.ymaps) {
      return Promise.resolve(window.ymaps);
    }
    if (deferTimes) {
      loader = deferLoadScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=6143d39b-0866-4538-832a-040c23830cd9&load=package.map&suggest_apikey=178249e4-e119-47b5-992f-10a933bf2285', deferTimes);
    } else {
      loader = loadScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=6143d39b-0866-4538-832a-040c23830cd9&load=package.map&suggest_apikey=178249e4-e119-47b5-992f-10a933bf2285');
    }
  }
  return loader;
}
